import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CartService {


  private cart: any[] = [];


  // =========================================================
  // ADD TO CART
  // =========================================================

  addToCart(product: any): void {

    const existing =
      this.cart.find(
        item =>

          item.name ===
          product.name

          &&

          item.quantity ===
          product.quantity
      );


    if (existing) {

      existing.qty++;

    }

    else {

      this.cart.push({
        ...product,
        qty: 1
      });

    }

  }


  // =========================================================
  // GET CART
  // =========================================================

  getCart(): any[] {

    return this.cart;

  }


  // =========================================================
  // DECREASE
  // =========================================================

  decreaseQty(product: any): void {

    const item =
      this.cart.find(
        item =>

          item.name ===
          product.name

          &&

          item.quantity ===
          product.quantity
      );


    if (!item) {

      return;

    }


    item.qty--;


    if (item.qty <= 0) {

      this.cart =
        this.cart.filter(
          cartItem =>
            cartItem !== item
        );

    }

  }


  // =========================================================
  // CLEAR CART
  // =========================================================

  clearCart(): void {

    this.cart = [];

  }

}